/* eslint-disable react/destructuring-assignment */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import moment from 'moment';
import * as constantMessageData from '../../../../../../SharedModules/Errors/constantMessageData';

// custom function import
import { validDate } from '../../../../../../SharedModules/CommonUtilities/commonUtilities';

import {
  MinDate,
  MaxDate,
  dateFormatForDatePicker,
  dateFormatDatePicker,
} from '../../../../../../SharedModules/CommonConstants/commonConstants';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../../../SharedModules/DateUtilities/DateUtilities';
import {
  dispatchErrorMessages,
  dispatchSetHolidaysDetails,
} from '../../../store/actions';

export default (props) => {
  const dispatch = useDispatch();
  const { colId } = props.column;
  const holidayData = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.holiday
  );
  const errorMessages = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.errorMessages
  );
  let rowIndex = 0;
  if (holidayData && holidayData.length > 0) {
    rowIndex = holidayData.findIndex((x) => {
      return x.id === props.data?.id;
    });
  }

  const setErrorMessages = (messages) => {
    dispatch(dispatchErrorMessages(messages));
  };
  // handing on change date event
  const handleOnChangeDateFields = (d, name) => {
    const newObj = [...holidayData];
    let localErr = errorMessages || [];
    if (d !== 'Invalid Date') {
      newObj[rowIndex][name] = d;
      newObj[rowIndex].newRow = true;
      newObj[rowIndex].holidayDtErr = false;
      props.node.setDataValue(colId, d);
      dispatch(dispatchSetHolidaysDetails(newObj));
    }
    localErr = localErr?.filter((item) => {
      return (
        !item.includes(
          `${constantMessageData.HOLIDAY_DATE_REQUIRED}${rowIndex + 1}`
        ) &&
        !item.includes(
          `${constantMessageData.DATE_INVALID_FORMAT_ERROR_HOLIDAY_DATE}${
            rowIndex + 1
          }`
        ) &&
        !item.includes(
          `${constantMessageData.MINIMUM_HOLIDAY_DATE_ERROR_DRUG_FAMILY}${
            rowIndex + 1
          }`
        )
      );
    });
    setErrorMessages([...new Set(localErr)]);
  };

  // call on Blur event filed level
  const handleOnBlurDate = (d) => {
    const newObj = [...holidayData];
    props.setDisabledSaveCancelBtn(false);
    let localErr = errorMessages || [];
    let { value } = d.target;
    if (d.target.value && d.target.value.length > 5) {
      const data = d.target.value.split('/');
      if (data[2].split('_').length === 3) {
        value = moment(d.target.value, 'MM/DD/YY').format('MM/DD/YYYY');
      }
    }
    if (value === '' || value === null || value === 'Invalid Date') {
      props.node.setDataValue(colId, value);
      newObj[rowIndex][colId] = value;
      localErr = localErr?.filter((item) => {
        return (
          !item.includes(
            `${constantMessageData.HOLIDAY_DATE_REQUIRED}${rowIndex + 1}`
          ) &&
          !item.includes(
            `${constantMessageData.DATE_INVALID_FORMAT_ERROR_HOLIDAY_DATE}${
              rowIndex + 1
            }`
          ) &&
          !item.includes(
            `${constantMessageData.MINIMUM_HOLIDAY_DATE_ERROR_DRUG_FAMILY}${
              rowIndex + 1
            }`
          )
        );
      });
      newObj[rowIndex].holidayDtErr = true;
      localErr.push(
        `${constantMessageData.HOLIDAY_DATE_REQUIRED}${rowIndex + 1}.`
      );
    } else if (value && validDate(new Date(value)) === false) {
      props.node.setDataValue(colId, value);
      newObj[rowIndex][colId] = value;
      localErr = localErr?.filter((item) => {
        return (
          !item.includes(
            `${constantMessageData.HOLIDAY_DATE_REQUIRED}${rowIndex + 1}`
          ) &&
          !item.includes(
            `${constantMessageData.DATE_INVALID_FORMAT_ERROR_HOLIDAY_DATE}${
              rowIndex + 1
            }`
          ) &&
          !item.includes(
            `${constantMessageData.MINIMUM_HOLIDAY_DATE_ERROR_DRUG_FAMILY}${
              rowIndex + 1
            }`
          )
        );
      });
      newObj[rowIndex].holidayDtErr = true;
      localErr.push(
        `${constantMessageData.DATE_INVALID_FORMAT_ERROR_HOLIDAY_DATE}${
          rowIndex + 1
        }.`
      );
    } else if (
      value &&
      compareTwoDatesGreaterThanOrEqual(value, moment(MinDate))
    ) {
      localErr = localErr?.filter((item) => {
        return (
          !item.includes(
            `${constantMessageData.HOLIDAY_DATE_REQUIRED}${rowIndex + 1}`
          ) &&
          !item.includes(
            `${constantMessageData.DATE_INVALID_FORMAT_ERROR_HOLIDAY_DATE}${
              rowIndex + 1
            }`
          ) &&
          !item.includes(
            `${constantMessageData.MINIMUM_HOLIDAY_DATE_ERROR_DRUG_FAMILY}${
              rowIndex + 1
            }`
          )
        );
      });
      localErr.push(
        `${constantMessageData.MINIMUM_HOLIDAY_DATE_ERROR_DRUG_FAMILY}${
          rowIndex + 1
        }.`
      );
      props.node.setDataValue(colId, value);
      newObj[rowIndex][colId] = value;
      newObj[rowIndex].holidayDtErr = true;
    }
    // Can be used if validation occurs on onBlur event
    // else {
    //   let duplicateFound = false;

    //   for (let i = 0; i < holidayData.length; i += 1) {
    //     if (holidayData[i] && i !== rowIndex) {
    //       if (
    //         !holidayData[i].deleteFlag &&
    //         holidayData[i].holidayDt === value
    //       ) {
    //         duplicateFound = true;
    //         localErr.push(`Holiday date already exists at row #${i + 1}`);
    //         break;
    //       }
    //     }
    //   }

    //   if (!duplicateFound) {
    //     localErr = localErr?.filter((item) => {
    //       return !item.includes('Holiday date already exists');
    //     });
    //   }
    // }
    else {
      localErr = localErr?.filter((item) => {
        return (
          !item.includes(
            `${constantMessageData.HOLIDAY_DATE_REQUIRED}${rowIndex + 1}`
          ) &&
          !item.includes(
            `${constantMessageData.DATE_INVALID_FORMAT_ERROR_HOLIDAY_DATE}${
              rowIndex + 1
            }`
          ) &&
          !item.includes(
            `${constantMessageData.MINIMUM_HOLIDAY_DATE_ERROR_DRUG_FAMILY}${
              rowIndex + 1
            }`
          )
        );
      });
      newObj[rowIndex].holidayDtErr = false;
    }
    //dispatch(dispatchSetHolidaysDetails(newObj));
    setErrorMessages([...new Set(localErr)]);
  };

  return (
    <div data-testid='log-check-date-picker frr-remove-formClt-mt-label'>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          id={`${props.column.colId}_${props.rowIndex}`}
          label={`Check Date-${props.column.colId}_${props.rowIndex}`}
          data-testid='checkDate'
          inputProps={{ id: `${props.column.colId}_${props.rowIndex}` }}
          format={dateFormatForDatePicker}
          inputFormat={dateFormatForDatePicker}
          mask='__/__/____'
          minDate={
            colId === 'holidayDt' ? MinDate : new Date(props.data?.holidayDt)
          }
          maxDate={MaxDate}
          InputLabelProps={{
            shrink: true,
          }}
          className={
            holidayData &&
            holidayData[rowIndex] &&
            holidayData[rowIndex].holidayDtErr !== undefined &&
            holidayData[rowIndex].holidayDtErr
              ? 'td-active-cell tBill-validate frr-display-hidden-label frr-remove-formClt-mt-label'
              : 'frr-display-hidden-label frr-remove-formClt-mt-label'
          }
          InputProps={{
            readOnly: false,
            autoFill: false,
          }}
          placeholder={dateFormatDatePicker}
          value={props.value}
          onChange={(d) => {
            handleOnChangeDateFields(d, colId);
          }}
          onBlur={(e) => {
            handleOnBlurDate(e);
          }}
          disabled={props.isEnabledByRole === false || props.isReadOnly}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          onKeyDown={async (e) => {
            if (e.keyCode == 67) {
              // copy date
              await window.navigator?.clipboard.writeText(e?.target?.value);
            }
          }}
          helperText={null}
          error={null}
        />
      </MuiPickersUtilsProvider>
    </div>
  );
};
